/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Ruoli degli utenti. Ruoli previsti:   -*SUPERADMIN*  -*ADMIN*  -*OP_COMUNE*  -*OP_SCUOLA*  -*OP_CENTRO_COTTURA*  -*OP_PRATICA*  -*OP_PRATICA_ESERCENTE*  -*OP_SERVIZIO*  -*CITTADINO*  -*ESERCENTE*  -*CASSIERE*
 */
export enum AuthorityType {

    SUPERADMIN = 'SUPERADMIN',

    ADMIN = 'ADMIN',

    OP_COMUNE = 'OP_COMUNE',

    OP_SCUOLA = 'OP_SCUOLA',

    OP_CENTRO_COTTURA = 'OP_CENTRO_COTTURA',

    OP_PRATICA = 'OP_PRATICA',

    OP_PRATICA_ESERCENTE = 'OP_PRATICA_ESERCENTE',

    OP_SERVIZIO = 'OP_SERVIZIO',

    CITTADINO = 'CITTADINO',

    ESERCENTE = 'ESERCENTE',

    CASSIERE = 'CASSIERE'
}

